import { v4 as uuidv4 } from 'uuid';

export function DisclosureLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'DisclosureLayout',
		componentId: uuidv4(),
		props: Object.assign(
			{
				initialVisibility: 'hidden',
				animated: false,
			},
			props,
		),
		childrenComponents,
	};
}
